import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  Modal,
  Backdrop,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";
import { useDollar } from "../../../DollarPrice";
import { getAuthData } from "../../utils/auth";

const BANCO_RECEPTOR = "Banco Banesco";
const NUMERO_CUENTA = "0134-0319-82-3191111990";
const TELEFONO_PAGO_MOVIL = "0414-4282678";
const RIF = "J-408124637";
const apiUrl = process.env.REACT_APP_API_URL;

const PagoModal = ({ open, onClose, solicitud, onPagoRegistrado }) => {
  const { dollarPrice } = useDollar();

  const authData = getAuthData();
  const token = authData?.token;
  const vendedor_id = authData?.vendedorId;
  const supervisor_id = authData?.supervisorId;
  const email = authData?.email;
  // Estados principales
  const [numeroSolicitud, setNumeroSolicitud] = useState("");
  const [modalidadPago, setModalidadPago] = useState("");
  const [metodoPago, setMetodoPago] = useState("");
  const [precioPlan, setPrecioPlan] = useState(0);
  const [montoPagar, setMontoPagar] = useState(0);
  const [cuota, setCuota] = useState(0);
  const [tipoPlan, setTipoPlan] = useState("");

  const Producto = solicitud?.tipo_plan === "producto";
  const esServicio = tipoPlan?.toLowerCase() === "servicio";

  // Lógica financiera  
  const [montoInicialMinimo, setMontoInicialMinimo] = useState(0);
  const [montoRestante, setMontoRestante] = useState(0);
  const [cuotaRestante, setCuotaRestante] = useState(0);

  const [pagoData, setPagoData] = useState({
    bancoEmisorVes: "",
    referenciaPagoMovilVes: "",
    comprobante: null,
    observaciones: "",
  });

  const banks = [
    { value: "", label: "Seleccione un Banco" },
    { value: "Banesco", label: "Banco Banesco Banco Universal, C.A." },
    { value: "100% Banco", label: "100% Banco Banco Universal, C.A." },
    { value: "Banca Amiga", label: "Banca Amiga, Banco Microfinanciero" },
    { value: "Bancaribe", label: "Bancaribe, C.A. Banco Universal" },
    { value: "Banco Activo", label: "Banco Activo" },
    { value: "Banco Bicentenario", label: "Banco Bicentenario" },
    { value: "Banco Caroní", label: "Banco Caroní, C.A. Banco Universal" },
    { value: "Banco de la FANB", label: "Banco de la FANB" },
    { value: "Banco de Venezuela", label: "Banco de Venezuela" },
    { value: "Banco del Tesoro", label: "Banco del Tesoro" },
    { value: "Banco Exterior", label: "Banco Exterior, C.A. Banco Universal" },
    { value: "Banco Mercantil", label: "Banco Mercantil" },
    { value: "BNC", label: "Banco Nacional de Crédito (BNC)" },
    { value: "Banco Provincial", label: "Banco Provincial" },
    { value: "Banplus", label: "Banplus Banco Universal, C.A." },
  ];

  useEffect(() => {
    if (solicitud) {
      setNumeroSolicitud(solicitud.numero_solicitud || "");
      setModalidadPago(solicitud.modalidad_pago || "");
      setMetodoPago(solicitud.metodo_pago || "");
      setPrecioPlan(solicitud.precio_plan || 0);
      setCuota(solicitud.numero_cuotas || 0);
      setTipoPlan(solicitud.tipo_plan || 0);

    }
  }, [solicitud, open]);

  // Lógica de cálculo de inicial y restantes
  useEffect(() => {
    if (!open) return;

    const dolar = Number(dollarPrice) || 0;
    const precioBaseUSD = Number(precioPlan) || 0;

    let descuentoUSD = 0;
    let precioFinalUSD = precioBaseUSD;

    // 🔹 DESCUENTO SOLO PARA SERVICIOS EN USD
    if (esServicio && metodoPago === "USD") {
      descuentoUSD = precioBaseUSD * 0.20;
      precioFinalUSD = precioBaseUSD - descuentoUSD;
    }

    let inicialUSD = 0;
    let cuotaUSD = 0;
    let restanteUSD = 0;

    if (modalidadPago === "financiado") {
      const numeroCuotas = Number(cuota) || 1;
      cuotaUSD = precioFinalUSD / numeroCuotas;
      inicialUSD = cuotaUSD; // inicial = primera cuota
      restanteUSD = precioFinalUSD - inicialUSD;
    } else {
      inicialUSD = precioFinalUSD;
    }

    setMontoInicialMinimo(Number(inicialUSD.toFixed(2)));
    setMontoRestante(Number(restanteUSD.toFixed(2)));
    setCuotaRestante(Number(cuotaUSD.toFixed(2)));

    if (montoPagar === 0) {
      setMontoPagar(Number(inicialUSD.toFixed(2)));
    }

  }, [modalidadPago, metodoPago, dollarPrice, open, precioPlan, cuota, tipoPlan]);


  const handlePagoDataChange = (e) => {
    const { name, value } = e.target;
    setPagoData((prev) => ({ ...prev, [name]: value }));
  };

  const isFormValid = () => {
    if (montoPagar <= 0) return false;
    if (modalidadPago === "financiado" && montoPagar < montoInicialMinimo - 0.1) return false;

    if (metodoPago === "VES") {
      return pagoData.bancoEmisorVes && pagoData.referenciaPagoMovilVes && pagoData.comprobante;
    }
    return true; // En USD (Efectivo) no pedimos nada más
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {

      const formData = new FormData();

      // IDs de control
      formData.append("solicitud_id", solicitud.id);
      formData.append("cliente_id", solicitud.cliente_id);
      formData.append("vendedor_id", vendedor_id);
      formData.append("supervisor_id", supervisor_id);
      formData.append("numero_solicitud", numeroSolicitud);

      // Lógica de Cobranza
      formData.append("modalidad_pago", modalidadPago); // 'De contado' o 'financiado'
      formData.append("metodo_pago", metodoPago);       // 'USD' o 'VES'      
      formData.append("no_cuotas", cuota);             // Cantidad de cuotas (ej: 12)

      // Valores Monetarios
      let descuentoCalculado = 0;

      if (esServicio && metodoPago === "USD") {
        descuentoCalculado = Number(precioPlan) * 0.20;
      }

      formData.append("monto_pagado", montoPagar);     // Lo que entrega el cliente
      formData.append("descuento", descuentoCalculado); // El 20% si aplica

      // Monto Abonado USD: es el valor que realmente se resta de la deuda
      let montoAbonadoValue = 0;
      if (metodoPago === "USD") {
        montoAbonadoValue = Number(montoPagar) + descuentoCalculado;
      } else {
        // Si es VES, el monto abonado en USD es (monto_pagado / tasa)
        montoAbonadoValue = Number(montoPagar) / Number(dollarPrice);
      }

      formData.append("monto_usd", montoAbonadoValue.toFixed(2));
      formData.append("dollar_price", dollarPrice);

      // Datos Bancarios (Solo si es VES)
      if (metodoPago === "VES") {
        formData.append("banco_emisor", pagoData.bancoEmisorVes);
        formData.append("banco_receptor", BANCO_RECEPTOR);
        formData.append("referencia", pagoData.referenciaPagoMovilVes);
      }

      formData.append("comprobante", pagoData.comprobante);
      formData.append("fecha_pago", new Date().toISOString().slice(0, 19).replace('T', ' '));
      formData.append("observaciones", pagoData.observaciones || "");
      formData.append("estado_pago", modalidadPago === "financiado" ? "inicial_pagada" : "pagado");
      formData.append("tipo_servicio", solicitud.tipo_servicio);

      const response = await axios.post(`${apiUrl}/api/reporte-pagos/guardar-pago`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("Pago reportado exitosamente");
      onPagoRegistrado(response.data);
      onClose();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Error al registrar el pago");
    }
  };

  return (
    <Modal open={open} onClose={onClose} closeAfterTransition BackdropComponent={Backdrop}>
      <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "60%", bgcolor: "background.paper", boxShadow: 24, p: 4, borderRadius: 2, maxHeight: "90vh", overflowY: "auto" }}>

        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
          <Typography sx={{ fontFamily: "Bakbak One", color: "#0A4575" }} variant="h6">
            REPORTAR PAGO - <span style={{ color: "#000000" }}>#{numeroSolicitud}</span>
          </Typography>
          <Typography sx={{ fontFamily: "Bakbak One", color: "#0A4575", fontSize: "20px" }}>
            Precio Plan: <span style={{ color: "#000000" }}>
              {metodoPago === "VES" ? `Bs. ${(precioPlan * Number(dollarPrice)).toFixed(2)}` : `$${precioPlan.toFixed(2)}`}
            </span>
          </Typography>
        </Box>

        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={6}>
            <Typography sx={{ color: "#0A4575", fontSize: "18px" }}>
              Modalidad: <span style={{ color: "#000" }}>{modalidadPago}</span>
            </Typography>
          </Grid>
          <Grid item xs={6}>
            {solicitud?.tipo_plan === "producto" ? (
              /* Si es PRODUCTO: Ocultamos el select y mostramos solo el valor fijo */
              <Box sx={{
                p: 1.5,
                border: "1px solid #ccc",
                borderRadius: 1,
                backgroundColor: "#f9f9f9",
                display: "flex",
                flexDirection: "column",
                boxShadow: 3,
              }}>
                <Typography sx={{ fontWeight: "bold", color: "#0A4575" }}>
                  USD - Dólares Efectivo
                </Typography>
              </Box>
            ) : (
              /* Si es SERVICIO: Mostramos el select normal para elegir entre VES y USD */
              <FormControl fullWidth size="small" sx={{ boxShadow: 3, borderRadius: 1, backgroundColor: "#fff" }}>
                <InputLabel>Método de Pago</InputLabel>
                <Select
                  value={metodoPago}
                  onChange={(e) => setMetodoPago(e.target.value)}
                  label="Método de Pago"
                >
                  <MenuItem value="VES">VES (Bolívares)</MenuItem>
                  <MenuItem value="USD">USD (Dólares)</MenuItem>
                </Select>
              </FormControl>
            )}
          </Grid>
        </Grid>

        {modalidadPago === "financiado" && (
          <Box sx={{ mt: 1, mb: 2, p: 2, bgcolor: "#f5f5f5", borderRadius: 2, boxShadow: 3 }}>
            <Typography
              sx={{
                fontSize: 17,
                mb: 2,
                fontFamily: "Bakbak One",
                color: "#0A4575"
              }}
            >
              Información de Financiamiento
            </Typography>

            <Grid container spacing={2}>
              {/* INICIAL */}
              <Grid item xs={2}>
                <Typography sx={{ fontSize: 13, color: "#666" }}>
                  Inicial (1ra cuota):
                </Typography>

                <Typography sx={{ fontSize: 17, fontWeight: 700, color: "#d32f2f" }}>
                  {metodoPago === "USD"
                    ? `$ ${montoInicialMinimo}`
                    : `Bs. ${(montoInicialMinimo * dollarPrice).toFixed(2)}`
                  }
                </Typography>
              </Grid>

              {/* RESTANTE */}
              <Grid item xs={2}>
                <Typography sx={{ fontSize: 13, color: "#666" }}>
                  Restante:
                </Typography>

                <Typography sx={{ fontSize: 17, fontWeight: 600 }}>
                  {metodoPago === "USD"
                    ? `$ ${montoRestante}`
                    : `Bs. ${(montoRestante * dollarPrice).toFixed(2)}`
                  }
                </Typography>
              </Grid>

              {/* MONTO POR CUOTA */}
              <Grid item xs={2}>
                <Typography sx={{ fontSize: 13, color: "#666" }}>
                  Monto por Cuotas ({cuota}):
                </Typography>

                <Typography sx={{ fontSize: 17, fontWeight: 700, color: "#0A4575" }}>
                  {metodoPago === "USD"
                    ? `$ ${cuotaRestante}`
                    : `Bs. ${(cuotaRestante * dollarPrice).toFixed(2)}`
                  }
                </Typography>
              </Grid>

              {/* CUOTA */}
              <Grid item xs={2}>
                <Typography sx={{ fontSize: 13, color: "#666" }}>
                  Cuotas:
                </Typography>

                <Typography sx={{ fontSize: 17, fontWeight: 700, color: "#0A4575" }}>
                  {cuota}
                </Typography>
              </Grid>

              <Grid item xs={2}>
                <Typography sx={{ fontSize: 13, color: "#666" }}>
                  Precio Plan:
                </Typography>

                <Typography sx={{ fontSize: 17, fontWeight: 700, color: "#0A4575" }}>
                  {metodoPago === "USD"
                    ? `$ ${precioPlan}`
                    : `Bs. ${(precioPlan * dollarPrice).toFixed(2)}`
                  }
                </Typography>
              </Grid>
            </Grid>
          </Box>
        )}

        <form onSubmit={handleSubmit}>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={metodoPago === "USD" ? 4 : 4}>
              <TextField
                fullWidth
                label="Monto a Pagar"
                type="number"
                value={montoPagar}
                onChange={(e) => setMontoPagar(e.target.value)}
                size="small"
                sx={{ boxShadow: 3 }}
                InputProps={{
                  startAdornment: (
                    <Typography>
                      {metodoPago === "USD" ? "$" : "Bs."}
                    </Typography>
                  ),
                }}
                error={
                  modalidadPago === "financiado" &&
                  montoPagar < montoInicialMinimo - 0.1
                }
                helperText={
                  modalidadPago === "financiado" &&
                    montoPagar < montoInicialMinimo - 0.1
                    ? "Monto menor al mínimo"
                    : ""
                }
              />
            </Grid>

            {metodoPago === "VES" && (
              <>
                <Grid item xs={4}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Banco Emisor</InputLabel>
                    <Select name="bancoEmisorVes" value={pagoData.bancoEmisorVes} onChange={handlePagoDataChange} sx={{ boxShadow: 3 }}>
                      {banks.map((b) => <MenuItem key={b.value} value={b.value}>{b.label}</MenuItem>)}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <TextField fullWidth label="Referencia" name="referenciaPagoMovilVes" value={pagoData.referenciaPagoMovilVes} onChange={handlePagoDataChange} size="small" sx={{ boxShadow: 3 }} />
                </Grid>
              </>
            )}

            <Grid item xs={12}>
              <input type="file" hidden id="comprobante" onChange={(e) => setPagoData({ ...pagoData, comprobante: e.target.files[0] })} />
              <label htmlFor="comprobante">
                <Button variant="contained" component="span" fullWidth sx={{ mb: 1 }}>Subir Comprobante</Button>
              </label>
              {pagoData.comprobante && <Typography variant="caption">{pagoData.comprobante.name}</Typography>}

              <Box sx={{ p: 1, border: "1px dashed #0A4575", mt: 1, display: 'flex', justifyContent: 'space-between' }}>
                <Typography sx={{ fontSize: '12px' }}>{BANCO_RECEPTOR}: {NUMERO_CUENTA}</Typography>
                <Typography sx={{ fontSize: '12px' }}>RIF: {RIF}</Typography>
                <Typography sx={{ fontSize: '12px' }}>Pago Móvil: {TELEFONO_PAGO_MOVIL}</Typography>
              </Box>
            </Grid>


          </Grid>

          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
            <Button onClick={onClose} sx={{ mr: 2, background: "#cecdcdff", color: "#000" }}>Cancelar</Button>
            <Button type="submit" variant="contained" disabled={!isFormValid()}>Reportar Pago</Button>
          </Box>
        </form>
      </Box>
    </Modal>
  );
};

export default PagoModal;